/**
 * PWA Manager - Service Worker Registration Only
 * 
 * Strategy (v1.0): De-emphasize PWA install prompts
 * - Service worker continues to run for caching and performance
 * - No install prompt UI (removed per Frank's recommendation)
 * - Users can still manually install, but we don't encourage it
 * - Focus on mobile web experience in Safari/Chrome
 * 
 * Future (v1.1+):
 * - Android: Trusted Web Activity (TWA) with App Links
 * - iOS: Minimal native shell + Universal Links
 * 
 * Issue: #606
 */
export function PWAManager() {
  // Service worker registration happens in main.tsx
  // This component kept as placeholder for future TWA/native shell hooks
  return null;
}